import { render, staticRenderFns } from "./GiftCardMethodSelector.vue?vue&type=template&id=00ec2b6c"
import script from "./GiftCardMethodSelector.vue?vue&type=script&lang=js"
export * from "./GiftCardMethodSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports